import { IAction } from '@r1-frontend/shared/types/Redux';

import { BP42SubmitResult } from '~/src/packages/bp42/actions/thunk/submit';
import { BP42Action } from '~/src/packages/bp42/constants/actions';

const setSubmitResult = (result: BP42SubmitResult): IAction<BP42Action.SetSubmitResult, BP42SubmitResult> => ({
    type: BP42Action.SetSubmitResult,
    payload: {
        ...result,
    },
});

export default setSubmitResult;
